import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import LoginPage from "../Login/LoginPage";
import FilterComponent from "./FilterComponent";

import SearchIcon from "@mui/icons-material/Search";
import {
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

import axios from "axios";
import { API_BASE_URL } from "../../config";

const Header = ({ onSearch,onApplyFilters  }) => {
 
  const [loginOpen, setLoginOpen] = useState(false);
  const [loginType] = useState("operator");

  // ✅ FILTER STATE
  const [filterOpen, setFilterOpen] = useState(false);

  // Hostel search state
  const [cityQuery, setCityQuery] = useState("");
  const [hostelQuery, setHostelQuery] = useState("");

  // Food supplier search state
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    cityId: "",
    location: "",
    supplierName: "",
  });

  const location = useLocation();
  const navigate = useNavigate();


const getToday = () => {
  const today = new Date();
  const offset = today.getTimezoneOffset();
  const local = new Date(today.getTime() - offset * 60000);
  return local.toISOString().split("T")[0];
};
const [checkIn, setCheckIn] = useState(getToday());
const [checkOut, setCheckOut] = useState("");


  // ---------------- Menu ----------------


  // ---------------- Login ----------------
  const handleLoginClose = () => setLoginOpen(false);

  // ---------------- Filters ----------------
  const handleFilterOpen = () => setFilterOpen(true);
  const handleFilterClose = () => setFilterOpen(false);
const [filters, setFilters] = useState({
  sortOption: "",
  preference: "",
  gender: "",
  occupancy: [],
  priceRange: [0, 10000],
});

 const handleApplyFilters = (newFilters) => {
  setFilters(newFilters); // ✅ store filters

  if (onApplyFilters) {
    onApplyFilters(newFilters);
  }

  handleFilterClose();
};

  const handleHostelSearch = () => {
  const selectedCity = cities.find(
    (c) => c.id === Number(cityQuery)
  );

  const searchText = hostelQuery.trim();
  const cityId = selectedCity?.id;

  const params = new URLSearchParams();

  if (searchText) params.append("searchText", searchText);
  if (cityId) params.append("cityIds", cityId);

  // ✅ add filters
  if (filters.gender) params.append("gender", filters.gender);
  if (filters.preference) params.append("preference", filters.preference);
  if (filters.sortOption) params.append("sort", filters.sortOption);

  if (filters.occupancy.length > 0) {
    params.append("occupancy", filters.occupancy.join(","));
  }

  // ✅ FIX: only send price if changed
  if (
    filters.priceRange &&
    (filters.priceRange[0] !== 0 || filters.priceRange[1] !== 10000)
  ) {
    params.append("minPrice", filters.priceRange[0]);
    params.append("maxPrice", filters.priceRange[1]);
  }

if (checkIn) {
  params.append("searchCheckInDate", checkIn);
}

if (checkOut) {
  params.append("searchCheckOutDate", checkOut);
}

  const queryString = params.toString();
  navigate(queryString ? `/hostel?${queryString}` : "/hostel");
};

  // ---------------- Food Supplier Search ----------------
  const handleFoodSupplierSearch = () => {
    onSearch({
      cityId: formData.cityId,
      location: formData.location.trim(),
      supplierName: formData.supplierName.trim(),
    });
  };

  // ---------------- Input handling ----------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ---------------- Fetch cities ----------------
  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/public/getCity`, {filteredCity: true,})
      .then((response) => {
        const cityArray = Array.isArray(response.data)
          ? response.data
          : response.data.cities || [];
        setCities(cityArray);
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
        setCities([]);
      });
  }, []);

useEffect(() => {
  if (checkIn && checkOut && checkOut < checkIn) {
    setCheckOut("");
    return;
  }

  if (checkIn && !checkOut) {
    const nextDay = new Date(checkIn);
    nextDay.setDate(nextDay.getDate() + 1);

    const offset = nextDay.getTimezoneOffset();
    const local = new Date(nextDay.getTime() - offset * 60000);
    setCheckOut(local.toISOString().split("T")[0]);
  }

}, [checkIn, checkOut]); 
const getActiveFilterCount = () => {
  let count = 0;

  if (filters.gender) count++;
  if (filters.preference) count++;
  if (filters.sortOption) count++;
  if (filters.occupancy.length > 0) count++;

  if (
    filters.priceRange[0] !== 0 ||
    filters.priceRange[1] !== 10000
  ) {
    count++;
  }

  return count;
};
  // ---------------- Routes ----------------
  const isHostelRoute =
    location.pathname === "/" ||
    location.pathname.startsWith("/hostel") ||
    location.pathname.startsWith("/city");

  const isFoodSupplierRoute =
    location.pathname === "/foodSupplier";

  return (
    <>
      <header className="headerHomePage">
        {/* Menu toggle */}
        

        {/* ---------------- HOSTEL SEARCH ---------------- */}
        {isHostelRoute && (
          <div className="floating-search-wrapper">
            <div className="floating-search-card">
         <div className="floating-search-inner">
  {/* City */}
  <TextField
  select
  size="small"
  label="City"
  value={cityQuery}
  onChange={(e) => setCityQuery(e.target.value)}
  sx={{
  minWidth: 150,
  flex: 1
}}
>
  <MenuItem value="">All</MenuItem>
  {cities.map((city) => (
    <MenuItem key={city.id} value={city.id}>
      {city.cityName}
    </MenuItem>
  ))}
</TextField>

  {/* Property Name */}
  <TextField
  size="small"
  label="Property Name"
  value={hostelQuery}
  onChange={(e) => setHostelQuery(e.target.value)}
  sx={{
  minWidth: 180,
  flex: 1.5
}}
/>
  
  
  
{/* CHECK-IN */}
<div style={{ flex: 1, minWidth: "130px", position: "relative" }}>
  <span
    style={{
      position: "absolute",
      top: "-6px",
      left: "5px",
      background: "#fff",
      padding: "0 4px",
      fontSize: "10px",
      color: "#1976d2",
      fontWeight: 500,
    }}
  >
    Check-in
  </span>

  <input
    type="date"
    value={checkIn}
    min={getToday()}
    onChange={(e) => setCheckIn(e.target.value || "")}
    style={{
      height: "42px",
      border: "1.5px solid #1976d2",
      borderRadius: "8px",
      padding: "0 5px",
      fontSize: "14px",
      backgroundColor: "#fff",
      width: "100%",
    }}
  />
</div>

{/* CHECK-OUT */}
<div style={{ flex: 1, minWidth: "130px", position: "relative" }}>
  <span
    style={{
      position: "absolute",
      top: "-6px",
      left: "5px",
      background: "#fff",
      padding: "0 2px",
      fontSize: "10px",
      color: "#2e7d32",
      fontWeight: 500,
    }}
  >
    Check-out
  </span>

  <input
    type="date"
    value={checkOut}
    min={checkIn || getToday()}
    disabled={!checkIn}
    onChange={(e) => setCheckOut(e.target.value || "")}
    style={{
      height: "42px",
      border: "1.5px solid #2e7d32",
      borderRadius: "8px",
      padding: "0 5px",
      fontSize: "14px",
      backgroundColor: "#fff",
      width: "100%",
    }}
  />
</div>

  
 {/* ✅ GROUP FILTER + SEARCH */}
<div className="action-group">
  <Button
    variant="outlined"
    size="small"
    onClick={handleFilterOpen}
    sx={{ height: "40px", whiteSpace: "nowrap" }}
  >
    Filters {getActiveFilterCount() > 0 && `(${getActiveFilterCount()})`}
  </Button>

  <IconButton
    onClick={handleHostelSearch}
    className="search-btn-icon"
  >
    <SearchIcon />
  </IconButton>
</div>
</div>
         
            </div>
          </div>
        )}

        {/* ---------------- FOOD SUPPLIER SEARCH ---------------- */}
        {isFoodSupplierRoute && (
          <div className="header-search flex gap-2 items-center">
            <input
              type="text"
              placeholder="Location"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              onKeyDown={(e) =>
                e.key === "Enter" &&
                handleFoodSupplierSearch()
              }
              className="location-input w-64 h-12 px-4 rounded-md"
            />

            <FormControl
              fullWidth
              size="small"
              className="w-64"
            >
              <InputLabel>City</InputLabel>
              <Select
                name="cityId"
                value={formData.cityId}
                onChange={handleInputChange}
                label="City"
              >
                <MenuItem value="">All</MenuItem>
                {cities.map((city) => (
                  <MenuItem
                    key={city.id}
                    value={city.id}
                  >
                    {city.cityName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <input
              type="text"
              placeholder="Food Supplier Name"
              name="supplierName"
              value={formData.supplierName}
              onChange={handleInputChange}
              onKeyDown={(e) =>
                e.key === "Enter" &&
                handleFoodSupplierSearch()
              }
              className="supplier-input w-64 h-12 px-4 rounded-md"
            />

            {/* ✅ FIXED SEARCH ICON */}
            <IconButton onClick={handleFoodSupplierSearch}>
              <SearchIcon />
            </IconButton>
          </div>
        )}

        {/* ---------------- FILTER COMPONENT ---------------- */}
        <FilterComponent
  open={filterOpen}
  onClose={handleFilterClose}
  onApply={handleApplyFilters}
  filters={filters}   // ✅ add this
/>
      </header>

      {/* ---------------- LOGIN DIALOG ---------------- */}
      <Dialog
        open={loginOpen}
        onClose={handleLoginClose}
        PaperProps={{ style: { maxHeight: "90vh" } }}
      >
        <DialogTitle>Login</DialogTitle>
        <DialogContent>
          <LoginPage
            onClose={handleLoginClose}
            loginType={loginType}
            hideExtras={loginType === "hosteler"}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleLoginClose}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Header;